import { useMutation } from "react-query";
import { createStripeBillingPortalSession } from "../api/plans/createStripeBillingPortalSession";

export const useMutationCreateStripeBillingPortalSession = () =>
  useMutation(
    ["create-stripe-billing-portal-session"],
    createStripeBillingPortalSession
  );
